import React from 'react';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Box, Button } from '@mui/material';
import AutoAwesomeMotionOutlinedIcon from '@mui/icons-material/AutoAwesomeMotionOutlined';
import { AppContext } from '/@/app/AppContext';
import { useContext } from 'react';
import { formatDate } from '/@/app/utils';
import { route, routeAttrs } from '/@/app/routes';

export const CurrentPanelBar = () => {
    const location = useLocation();
    const { bootstrapData } = useContext(AppContext);
    const currentPanel = bootstrapData.panel;
    const count = bootstrapData.panels_count;

    if (currentPanel.is_latest && currentPanel.is_editable) {
        return <></>;
    }

    if (routeAttrs(location)._hideCurrentPanelBar) {
        return <></>;
    }

    let editableMark = null;
    if (!currentPanel.is_editable) {
        if (currentPanel.is_imported) {
            editableMark = <Box sx={{ color: 'red', m: 0, fontSize: "12px" }}>Неизменяема: данные из лаборатории.</Box>;
        } else {
            editableMark = <Box sx={{ color: 'red', m: 0, fontSize: "12px" }}>Неизменяема: Создана более 180 дней назад.</Box>;
        }
    }

    return (
        <Box
            sx={{
                position: 'fixed',
                bottom: 0,
                left: '50%',
                transform: 'translateX(-50%)',
                width: 'auto',
                height: 'auto',
                p: { xs: 1, sm: 2 },
                minWidth: { xs: "100vw", sm: "auto" },
                pb: { xs: 0, sm: 0 },
                borderRadius: { xs: 0, sm: "20px 20px 0 0" },
                boxShadow: `0px 3px 10px 0px rgba(0,0,0,0.6)`,
                backgroundColor: 'rgb(241, 242, 251, 0.9)',
                textAlign: 'center',
                zIndex: 1100,
            }}
        >
            <Box>Открыта панель от {formatDate(currentPanel.created_at)}</Box>
            {editableMark}
            <Button size="small" variant="text" component={Link} to={route('/panels/')}
                    sx={{ whiteSpace: "nowrap" }}
            >
                <AutoAwesomeMotionOutlinedIcon sx={{ mr: 1 }} /> Все мои панели ({count})
            </Button>
        </Box>
    );
};
